export default __webpack_public_path__ + "static/media/ic_filter.4193a3e5.svg";